firebase.initializeApp({
  apiKey: "AIzaSyBcMH36ztCuSR-95O4KrIExvXinMdgUR8k",
  authDomain: "biggest-fan-site.firebaseapp.com",
  databaseURL: "https://biggest-fan-site.firebaseio.com",
  projectId: "biggest-fan-site",
  storageBucket: "biggest-fan-site.appspot.com",
  messagingSenderId: "871968104501",
  appId: "1:871968104501:web:5c5780d6e29ea387df117c",
  measurementId: "G-LBTJ5HTCC9",
});
firebase.analytics();
const body = document.querySelector("body");
const config = { childList: true, subtree: true };

const callback = function (mutationsList, observer) {
  const mobileMenuButton = document.querySelector(".mobile-menu-button");
  const mobileMenuContainer = document.querySelector(".mobile-menu-container");
  const mobileMenuCloseButton = document.querySelector(".mobile-menu-close-button");
  
  if (!!mobileMenuButton
    && !!mobileMenuContainer
    && !!mobileMenuCloseButton) {

    mobileMenuButton.addEventListener("click", function () {
      mobileMenuContainer.classList.remove("hidden");
    });
    mobileMenuCloseButton.addEventListener("click", function () {
      mobileMenuContainer.classList.add("hidden");
    });
    observer.disconnect();
  }
};

const observer = new MutationObserver(callback);

observer.observe(body, config);
